<div [nbSpinner]="true" class="spinner" nbSpinnerSize="giant"></div>
